"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var i18next_1 = __importDefault(require("i18next"));
var localization_1 = require("./helpers/localization");
var Localization_1 = require("./constants/Localization");
var common_en = __importStar(require("./translations/en/common.json"));
var fields_en = __importStar(require("./translations/en/fields.json"));
var common_hy = __importStar(require("./translations/hy/common.json"));
var fields_hy = __importStar(require("./translations/hy/fields.json"));
var common_ru = __importStar(require("./translations/ru/common.json"));
var fields_ru = __importStar(require("./translations/ru/fields.json"));
var mergedObject_en = __assign(__assign({}, fields_en), common_en);
var mergedObject_hy = __assign(__assign({}, common_hy), fields_hy);
var mergedObject_ru = __assign(__assign({}, common_ru), fields_ru);
i18next_1.default.init({
    lng: localization_1.getLanguage(),
    resources: {
        en: {
            common: mergedObject_en,
        },
        hy: {
            common: mergedObject_hy,
        },
        ru: {
            common: mergedObject_ru,
        },
    },
    defaultNS: Localization_1.LocalizationSettings.defaultLanguage,
});
exports.default = i18next_1.default;
